import { useEffect, useState } from 'react'
import Loading from '../../../../load/loading';
import RegisterAccess from '../../../../utils/registerAccess';
import HeaderSession from '../../../../utils/headerSession';
import { Box, Button, Container, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import Paper from '@mui/material/Paper';
import api from '../../../../services/api';
import MessageError from '../../../../messages/messageError';
import Montante from '../../../../utils/montante';
import GetDoc from '../../../../utils/getDoc';

const FinancasPage = () => {
    const [loading, setLoading] = useState(false);
    const [emolumentoCriado, setEmolumentoCriado] = useState([]);
    const [messageError, setMessageError] = useState('');

    useEffect(() => {
        setLoading(true)
        api.get(`/emolumentos`)
            .then((response) => {
                setLoading(false);
                setEmolumentoCriado(response.data.emolumentos || []);
            })
            .catch((err) => {
                setLoading(false);
                setMessageError(err.response?.data?.message || 'Erro ao buscar emolumentos');
            });

    }, []);

    return (
        <Container style={{ minHeight: '73vh', }}>
            <RegisterAccess page={'Emolumentos'} />
            <HeaderSession title={'EMOLUMENTOS'} />

            {messageError && <MessageError message={messageError} />}

            <div style={{ display: 'flex', gap: '10px', flexDirection: 'column' }}>
                <Box>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Designação</TableCell>
                                    <TableCell align='left' sx={{ fontWeight: 'bold' }}>Valor</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Açōes</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    (emolumentoCriado.map((emolumento, index) => (
                                        <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell style={{ fontSize: 16 }}>{emolumento?.designacao}</TableCell>
                                            <TableCell align='left'><Typography noWrap> <Montante montante={emolumento?.valor} /></Typography></TableCell>
                                            <TableCell align='left'>
                                                <Button variant="contained" style={{ backgroundColor: '#99288b', cursor: 'pointer', fontSize: '11px' }}>Gerar Rupe</Button>
                                            </TableCell>
                                        </TableRow>
                                    )))
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>

                {loading && <Loading text={'A carregar emolumentos...'} />}
            </div>
            <Typography align="center" variant="h1" style={{ marginTop: 60, fontSize: 25, fontWeight: 'bold' }}>
                DIÁRIO DA REPÚBLICA
                <br />
                <GetDoc title={'Baixar Diário da República'} id={''} />
            </Typography>
        </Container>
    )
}

export default FinancasPage
